import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, ordersAwaitingConfirmActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, ordersAwaitingConfirmActions);

export default slice.reducer;
